// extracted by mini-css-extract-plugin
export default {"MenubarContainer":"Menubar_MenubarContainer__sHDxr","MenubarTitle":"Menubar_MenubarTitle__DmKY4"};